<risr-resource-wrapper [resource]="reportResource">
    @if (reportResource.hasValue()) {
        @let report = reportResource.value();
        <risr-header-card>
            <h1 risrHeaderCardTitle>{{ report?.name }}</h1>
        </risr-header-card>

        @let runnableReport = report?.report;
        @let remoteUser = $remoteUser();
        @if (runnableReport && remoteUser) {
            <risr-features-reports-report-run [report]="runnableReport" [reportId]="report.id" [runFor]="remoteUser" [showType]="'full'"></risr-features-reports-report-run>
        }
    }
</risr-resource-wrapper>
